import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'linkify' })
export class LinkifyPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {}

	private readonly fileExtensions = [
		// Images
		'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg',
		// Documents
		'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt',
		// Archives
		'zip', 'rar', '7z', 'tar', 'gz',
		// Audio/Video
		'mp3', 'mp4', 'wav', 'avi', 'mov',
		// Other common formats
		'csv', 'json', 'xml'
	];

	transform(value: string): SafeHtml {
		if (!value) return '';

		let processedValue = value;

		// Handle Markdown format links with text
		const markdownRegex = /\[(.*?)\]\((https:\/\/[^\s)]+(?:classvaluation\.com|s3\.amazonaws\.com)[^\s)]+)\)/g;
		processedValue = processedValue.replace(markdownRegex, (match, text, url) => {
			return this.createLink(url.trim(), text.trim());
		});

		// Handle plain URLs that aren't already part of an HTML tag
		const urlRegex = /(?<!href=")(https:\/\/[^\s"<>]+(?:classvaluation\.com|s3\.amazonaws\.com)[^\s"<>]+)(?!")/g;
		processedValue = processedValue.replace(urlRegex, (url) => {
			return this.createLink(url);
		});

		// Convert newlines after processing URLs
		processedValue = processedValue.replace(/\n/g, '<br>');

		return this.sanitizer.bypassSecurityTrustHtml(processedValue);
	}

	private createLink(url: string, displayText?: string): string {
		// Remove any trailing punctuation or quotes
		url = url.replace(/[.,!?'"]+$/, '');

		const filename = url.split('/').pop() || url;

		const isFile = this.fileExtensions.some(ext =>
			filename.toLowerCase().endsWith(`.${ext}`)
		);

		if (isFile) {
			return `<a href="${url}" target="_blank" style="display: inline-flex; align-items: center; gap: 8px; text-decoration: none;">
                <i class="fas fa-file"></i>
                <span>${displayText || filename}</span>
            </a>`;
		}
		return `<a href="${url}" target="_blank">${displayText || url}</a>`;
	}
}
